<template>
    <div>
        <div class="toppage-menu-area">
            <ul class="toppage-menu">
                <li v-bind:class="{ active: isActive('/plus') }"><a href="/plus"><img
                            src="/src/assets/img/toppage/plus-menu_001.svg"></a></li>
                <li v-bind:class="{ active: isActive('/plus/special/archives') }"><a href="/plus/special/archives/">＋Special</a></li>
                <li v-if="season_girl_started" v-bind:class="{ active: isActive('/plus/season_girl/archives') }"><a href="/plus/season_girl/archives/">＋Season Girl</a></li>
                <li v-bind:class="{ active: isActive('/plus/dvd') }"><a href="/plus/dvd">＋付録DVD</a></li>
                <li v-bind:class="{ active: isActive('/plus/weekly') }"><a href="/plus/weekly">＋Weekly </a></li>
                <li v-bind:class="{ active: isActive('/plus/mycollection') }"><a href="/plus/mycollection">＋マイコレ</a></li>
                <li v-bind:class="{ active: isActive('/plus/column') }"><a href="/plus/column">コラム</a></li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            'season_girl_started': false,
        },

        methods: {
            isActive(current) {
                if ( current === '/plus' && current !== location.pathname) {
                    // /plus以外の時に/plusも一緒に前方一致しないように検知してfalseを返す。
                    return false;
                } else if (current === location.pathname){
                    return true;
                } else if ( location.pathname.indexOf(current+'/') >=0 ){
                    return true;
                } else {
                    return false;
                }
            }
        },
    };

</script>

<style lang="scss" scoped>
    .toppage-menu-area+div {
        padding-top: 40px;
    }

    .toppage-menu-area {
        width: 100%;
        background: #2D2D2D;
        height: 40px;
        z-index: 15;
    }

    .toppage-menu {
        max-width: 1024px;
        margin: 0 auto;
        display: flex;
        height: 40px;
        justify-content: space-between;
    }

    @media (max-width:575px) {
        .toppage-menu {
            overflow: scroll;
            scrollbar-width: none;
            -ms-overflow-style: none;
        }

        .toppage-menu::-webkit-scrollbar {
            display: none;
        }
    }

    .toppage-menu li {
        height: 40px;
        width: auto;
        text-align: center;
        font-size: 13px;
        font-weight: bold;
        line-height: 37px;
        white-space: nowrap;
        margin: 0;
    }

    @media (max-width:575px) {
        .toppage-menu li {
            margin: 0 5px;
        }
    }

    .toppage-menu li a:hover {
        border-bottom: 3px solid #E47931;
    }

    .toppage-menu li:last-child a:hover {
        border-bottom: 3px solid #fff;
    }

    .toppage-menu li a {
        display: block;
        color: #ababab;
        padding: 0 10px;
    }

    @media (max-width:575px) {
        .toppage-menu li a {
            padding: 0 5px;
        }
    }

    .toppage-menu li a:hover {
        color: #fff;
    }

    .toppage-menu li.active {
        border-bottom: 3px solid #E47931;
    }

    .toppage-menu li.active:last-child {
        border-bottom: 3px solid #fff;
    }

    .toppage-menu li.active a {
        pointer-events: none;
        color: #fff;
    }

    .toppage-menu li a img {
        height: 40px;
        width: auto;
    }

</style>
